import useIsFCM from '../useIsFCM';
import useIsFeatureFlagEnabled from './useIsFeatureFlagEnabled';

const useDecommisionTME = () => useIsFeatureFlagEnabled('decomissionTme');
export const useAllowRiskMgmtCDE = () => {
  const isFCM = useIsFCM();
  const decommissionTmeEnabled = useDecommisionTME();
  return isFCM && !decommissionTmeEnabled;
};

export default useDecommisionTME;
